import { useEffect } from "react";
import { Divider, Spinner, Tab, Tabs } from "@heroui/react";
import {
    createFileRoute,
    Link,
    Outlet,
    useMatch,
    useNavigate,
} from "@tanstack/react-router";
import useAuth from "@/lib/auth/useAuth";
import useLayout from "@/lib/layout/useLayout";

export const Route = createFileRoute("/dashboard/resources")({
    component: RouteComponent,
});

function RouteComponent() {
    const { userIsSentinel, isFetched } = useAuth();
    const { setLayoutState } = useLayout();
    const navigate = useNavigate();
    const cspView = useMatch({
        from: "/dashboard/resources/csp-view",
        shouldThrow: false,
    });
    const upload = useMatch({
        from: "/dashboard/resources/upload",
        shouldThrow: false,
    });
    const tab = [cspView, upload]
        .find((match) => !!match)
        ?.fullPath.split("/")
        .pop();

    useEffect(() => {
        setLayoutState("full_screen");
    }, [setLayoutState]);

    useEffect(() => {
        if (isFetched && !userIsSentinel) {
            navigate({ to: "/dashboard/home", replace: true });
        }
    }, [isFetched, navigate, userIsSentinel]);

    if (!isFetched || !userIsSentinel) {
        return (
            <div className="flex h-full items-center justify-center">
                <Spinner label="Loading resources" />
            </div>
        );
    }

    return (
        <div className="flex h-full flex-col overflow-hidden">
            <Tabs variant="underlined" color="primary" selectedKey={tab}>
                <Tab
                    key="csp-view"
                    as={Link}
                    // @ts-expect-error ts(2322)
                    to="/dashboard/resources/csp-view"
                    title="CSP View"
                />
                <Tab
                    key="upload"
                    as={Link}
                    // @ts-expect-error ts(2322)
                    to="/dashboard/resources/upload"
                    title="Upload"
                />
            </Tabs>
            <Divider />
            <Outlet />
        </div>
    );
}
